import React from 'react';
import { withRouter } from 'react-router';
import { isMobile } from 'react-device-detect';
import MobileHeader from '../../../components/Common/Header/';

const NotFoundPage = () => {
  const svgUrl = (isMobile && '/svg/404-mobile.svg') || '/svg/404-web.svg';
  return (
    <React.Fragment>
      <MobileHeader />
      <div className="container not-found-page">
        <h5>OPPPS!</h5>
        <p>We could not reach the page you were looking for!</p>
        <a href="/" className="btn btn-blue">
          Back to homepage
        </a>
        <div className="svg">
          <img src={svgUrl} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(NotFoundPage);
